import { BaseService } from "./BaseService";
import { Environment, EnvironmentClient } from "./Client/ServiceClient";
import { Configuration } from "Configuration";

/**
 * Service which gets the menu.
 * @hidden
 */
export class EnvironmentService extends BaseService {
    /**
     * Get user environment.
     */
    public get(): Promise<Environment> {
        let client = new EnvironmentClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();

        return this.handleResult(
            new Promise<Environment>((resolve, reject) => {
                client.get(
                    (res) => resolve(res),
                    (exception, reason) => reject(exception)
                );
                // cancellationTokenSource.token.onCancelled((reason) => {
                //     xhr.abort();
                //     reject(reason);
                // });
            })
        );
    }
}
